package com.htmlagent.site.state

import arrow.core.Either
import arrow.core.right
import com.htmlagent.site.api.AgentClient
import com.htmlagent.site.api.ApiFailure

/**
 * Who this browser is signed in as, or `null` for nobody. A 401 is an answer, not a failure.
 *
 * With no session, a guest key an older version kept in `localStorage` is resumed once and then
 * deleted: those guests were promised their pages would be here, and the key is what proves it.
 * An address stored the same way is not trusted - anyone could type one - and waits for the link.
 */
suspend fun AgentClient.signedInIdentity(): Either<ApiFailure, String?> =
    when (val me = me()) {
        is Either.Right -> Identity.of(me.value).right()
        is Either.Left -> if (me.value.isUnauthenticated()) resumeLegacyGuest() else me
    }

private suspend fun AgentClient.resumeLegacyGuest(): Either<ApiFailure, String?> {
    val key = Identity.legacy()?.takeIf(Identity::isGuest) ?: return null.right()
    return guest(key).map { me ->
        Identity.forgetLegacy()
        Identity.of(me)
    }
}

private fun ApiFailure.isUnauthenticated(): Boolean = this is ApiFailure.Problem && status == UNAUTHORIZED

private const val UNAUTHORIZED = 401
